import request from '@/util/http'

/**
 * 启用币种列表 + 当前汇率（公开，访客可访问）
 */
export function getCurrencyList() {
  return request({ url: '/upms/shop/currency/list', method: 'get' })
}

/**
 * 保存当前登录会员的展示币种偏好
 */
export function saveCurrencyPreference(currencyCode) {
  return request({ url: '/upms/member/currency/preference', method: 'post', params: { currencyCode } })
}
